import { colorSet, theme } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyle = makeStyles(() => {
  return {
    dialogPaper: {
      width: 375,
      maxHeight: 617,

      '&.MuiPaper-rounded': {
        borderRadius: '16px'
      }
    },
    header: {
      position: 'relative',
      padding: `28px 24px`
    },
    content: {
      padding: `8px 16px`,
      borderTop: 0
    },
    reviewReportContent: {
      padding: 0,
      borderTop: 0,

      '& .reviewBox': {
        width: '100%',
        padding: `20px 24px`,

        backgroundColor: colorSet.gray200
      },
      '& .reportReason': {
        padding: `24px 16px`
      },
      '& .checkBoxGroup': {
        padding: `0px 24px`,

        '& .MuiFormGroup-root': {
          flexDirection: 'row',

          '& .MuiFormControlLabel-root': {
            minWidth: 158
          }
        }
      },
      '& .textFieldBox': {
        padding: `20px 16px 48px`
      }
    },
    reviewEvent: {
      display: 'flex',
      gap: '8px',
      margin: `0px 16px`,
      padding: 12,
      width: 343,
      height: 44,
      borderRadius: '4px',
      backgroundColor: colorSet.primary200
    },

    partnerInfo: {
      padding: `14px 12px`,
      gap: '12px'
    },
    reviewWrite: {
      '& .chipBox': {
        paddingTop: 16,
        justifyContent: 'center',
        gap: `4px`
      },
      '& .comment': {
        width: '100%',
        padding: `24px 0px`
      }
    },
    numberOfLetters: {
      marginTop: 4,
      float: 'right'
    },
    attachPictures: {
      gap: '8px',

      '& .photoBox': {
        width: '100%',
        padding: 16,
        height: 48,
        border: `1px solid ${colorSet.gray600}`,
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        cursor: 'pointer'
      }
    },
    checkDueDate: {
      padding: `24px 0px 16px`,

      '& .checkBoxContainer': {
        gap: '8px',
        '& .checkBox': {
          width: '100%',
          padding: `22px 16px`,
          height: 64,
          border: `1px solid ${colorSet.gray400}`,
          borderRadius: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '4px',
          cursor: 'pointer',

          '&:hover': {
            borderColor: colorSet.gray900
          },
          '&.checked': {
            borderColor: colorSet.gray900,
            backgroundColor: colorSet.gray100
          },

          '& .MuiCheckbox-root': {
            color: colorSet.gray900
          }
        }
      }
    },
    productionPeriod: {
      '& .periodBox': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',

        '& .waveLetter': {
          padding: `0px 8px`
        }
      }
    },
    iconButton: {
      position: 'absolute',
      top: 12,
      right: 12
    },
    divider: {
      height: 12,
      background: colorSet.gray300
    },
    footer: {
      display: 'contents',
      '& .button': {
        margin: `16px 24px`
      }
    },
    textField: {
      width: '100%',
      '& .MuiOutlinedInput-input': {
        padding: `10.7px 12px`
      },
      '& .MuiOutlinedInput-input::placeholder': {
        ...theme.typography.body2,
        fontWeight: 400,
        color: colorSet.gray500
      }
    },
    question: {
      padding: `16px 0px`
    },
    reviewWriteCompleteDialogContent: {
      padding: `0px 16px`,
      borderTop: 0,
      borderBottom: 0
    },
    reviewWriteCompleteContainer: {
      '& .notification': {
        width: '100%',
        height: 96,
        padding: 16,
        backgroundColor: colorSet.gray100
      },
      '& .image': {
        width: 206
      }
    },
    imageContainer: {
      // width: '80%',
      // [theme.breakpoints.down('xs')]: {
      //   width: '100%',
      //   justifyContent: 'center'
      // },
      paddingTop: 4,
      gap: '7px',
      '& .imageBox': {
        position: 'relative',

        '& .deleteButton': {
          position: 'absolute',
          top: 0,
          right: 0,
          width: 24,
          height: 24,
          backgroundColor: colorSet.gray900,
          borderRadius: 0,
          '&:hover': {
            backgroundColor: colorSet.gray2000
          },
          '& .MuiIconButton-label': {
            width: 'unset'
          }
        }
      }
    }
  };
});

export default useStyle;
